var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.142,
    height: 14.142,
    viewBox: "0 0 14.142 14.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2120",
    "data-name": "Rectangle 2120",
    width: 10,
    height: 10,
    rx: 1,
    transform: "translate(0 7.071) rotate(-45)",
    fill: "#777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond1);
export default __webpack_public_path__ + "static/media/Diamond (1).e00acabc20ed5ff47d4b667990d73ea2.svg";
export { ForwardRef as ReactComponent };